module.exports = __webpack_public_path__ + "static/img/cycleAI-full.b901875.svg";